const registerAnimations = ($) => {
  var windowHeight = window.innerHeight;
  var windowWidth = window.innerWidth;
  var prepare = windowHeight / 3;

  // ***** SECTION 1 *****

  $(window).on('load', function () {
    $('.banner .leaf-1, .banner .leaf-2').addClass('fadeInDown');
    if (windowWidth < 992) {
      $('.banner .leaf-3').addClass('fadeInDown');
    } else {
      var windowScroll = $(window).scrollTop();
      if ($('.banner .leaf-3').length) {
        var leaf3 = $('.banner .leaf-3').offset().top;

        if (windowScroll + windowHeight - prepare * 2 > leaf3) {
          $('.banner .leaf-3').addClass('fadeInDown');
        }
        $(window).on('scroll', function () {
          windowScroll = $(window).scrollTop();
          leaf3 = $('.banner .leaf-3').offset().top;
          if (windowScroll + windowHeight - prepare * 0.5 > leaf3) {
            $('.banner .leaf-3').addClass('fadeInDown');
          }
          //console.log(leaf3);
        });
      }
    }
  });

  // ***** SECTION 2 *****

  windowHeight = window.innerHeight;
  windowWidth = window.innerWidth;
  prepare = windowHeight / 1;

  $(document).ready(function () {
    $('.features ul').addClass('animatable');
    var windowScroll = $(window).scrollTop();
    if ($('.features ul').length) {
      var sec2_part_1 = $('.features ul').offset().top;

      if (windowScroll + windowHeight - prepare * 2 > sec2_part_1) {
        $('.features ul').addClass('animate');
      }
      $(window).on('scroll', function () {
        windowScroll = $(window).scrollTop();
        sec2_part_1 = $('.features ul').offset().top;
        if (windowScroll + windowHeight - prepare * 2 > sec2_part_1) {
          $('.features ul').addClass('animate');
        }
        // console.log(sec2_part_1);
      });
    }
    // sec2-bg
    if ($('.sec2-bg').length) {
      var sec2bg = $('.sec2-bg').offset().top;

      if (windowScroll + windowHeight - prepare * 2 > sec2bg) {
        $('.sec8 .animated').addClass('fadeIn');
      }
      $(window).on('scroll', function () {
        windowScroll = $(window).scrollTop();
        sec2bg = $('.sec2-bg').offset().top;
        if (windowScroll + windowHeight - prepare * 1.5 > sec2bg) {
          $('.sec2-bg').addClass('fadeIn');
        }
        //console.log(sec2bg);
      });
    }

    // slider
    $('.shoes-color')
      .not('.slick-initialized')
      .slick({
        centerMode: true,
        centerPadding: '60px',
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              centerPadding: '40px',
              slidesToShow: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              centerPadding: '40px',
              slidesToShow: 1,
            },
          },
        ],
      });
  });

  // ***** SECTION 3 *****

  windowHeight = window.innerHeight;
  windowWidth = window.innerWidth;
  prepare = windowHeight / 4;
  $(window).on('scroll', function () {
    var slipper = $('#slipper-animation').offset().top;

    var slipperScrollUpTO = 215;
    if (windowWidth >= 375 && windowWidth < 410) {
      slipperScrollUpTO = 250;
    }
    if (windowWidth >= 410 && windowWidth < 480) {
      slipperScrollUpTO = 300;
    }
    if (windowWidth >= 480 && windowWidth < 768) {
      slipperScrollUpTO = 350;
    }
    if (windowWidth >= 768 && windowWidth < 1200) {
      slipperScrollUpTO = 350;
    }
    if (windowWidth >= 1200 && windowWidth < 1440) {
      slipperScrollUpTO = 450;
    }
    if (windowWidth >= 1440 && windowWidth < 1600) {
      slipperScrollUpTO = 520;
    }
    if (windowWidth >= 1600) {
      slipperScrollUpTO = 580;
    }

    var windowScroll = $(window).scrollTop();

    var slipperScroll = windowScroll + windowHeight - slipper - prepare;
    if (windowScroll + windowHeight - prepare > slipper && slipperScroll > 0) {
      //console.log(windowScroll);
      if (slipperScroll <= slipperScrollUpTO) {
        $('#layer-inside').css({ transform: 'translateY(' + slipperScroll / 1.5 + 'px)' });
        $('#layer-bottom').css({ transform: 'translateY(' + slipperScroll / 1.2 + 'px)' });
        $('#layer-base').css({ transform: 'translateY(' + slipperScroll / 1.1 + 'px)' });
      } else {
        //console.log("slipperScrollUpTO : " + slipperScrollUpTO + " | slipperScroll : " + slipperScroll);
      }
    } else {
      $('#layer-inside').css({ transform: 'translateY(' + 0 + 'px)' });
      $('#layer-bottom').css({ transform: 'translateY(' + 0 + 'px)' });
      $('#layer-base').css({ transform: 'translateY(' + 0 + 'px)' });
    }
  });

  // ***** SECTION 7 *****

  windowHeight = window.innerHeight;
  windowWidth = window.innerWidth;
  prepare = windowHeight / 3;

  $(document).ready(function () {
    var windowScroll = $(window).scrollTop();
    if ($('.sec7').length) {
      var sec7 = $('.sec7 .circle-cont').offset().top;

      if (windowScroll + windowHeight - prepare * 2 > sec7) {
        $('.sec7 .circle-cont').addClass('zoomIn');
        $('.sec7 .merino-shoe-img').addClass('fadeInUpShort');
      }
      $(window).on('scroll', function () {
        windowScroll = $(window).scrollTop();
        sec7 = $('.sec7 .circle-cont').offset().top;
        if (windowScroll + windowHeight - prepare * 1.25 > sec7) {
          $('.sec7 .circle-cont').addClass('zoomIn');
          $('.sec7 .merino-shoe-img').addClass('fadeInUpShort');
        }
        //console.log(sec7);merino-shoe-img
      });
    }

    if ($('.sec7 .shoe-grip-img').length) {
      var sec7_grip = $('.sec7 .shoe-grip-img').offset().top;

      if (windowScroll + windowHeight - prepare * 2 > sec7_grip) {
        $('.sec7 .shoe-grip-img').addClass('fadeInRight');
      }
      $(window).on('scroll', function () {
        windowScroll = $(window).scrollTop();
        sec7_grip = $('.sec7 .shoe-grip-img').offset().top;
        if (windowScroll + windowHeight - prepare * 1.25 > sec7_grip) {
          $('.sec7 .shoe-grip-img').addClass('fadeInRight');
        }
      });
    }
  });

  // ***** SECTION 8 *****

  windowHeight = window.innerHeight;
  windowWidth = window.innerWidth;
  prepare = windowHeight / 3;

  $(document).ready(function () {
    var windowScroll = $(window).scrollTop();
    if ($('.sec8').length) {
      var sec8 = $('.sec8 .footbed-img').offset().top;

      if (windowScroll + windowHeight - prepare * 2 > sec8) {
        $('.sec8 .animated').addClass('fadeInLeft');
      }
      $(window).on('scroll', function () {
        windowScroll = $(window).scrollTop();
        sec8 = $('.sec8 .footbed-img').offset().top;
        if (windowScroll + windowHeight - prepare * 1.25 > sec8) {
          $('.sec8 .animated').addClass('fadeInLeft');
        }
        //console.log(sec8);
      });
    }
  });
};

export default registerAnimations;
